export class Paciente{

    idPaciente: number;
    nomePacinte: string;
    prontuario: string;
    dataNascimento: Date;
    nomeMae: string;
    sexo: string;
    estadoCivil: string;
    eMail: string;
    codigoIBGE: string;
    municipio: string;
    uf: string;
    cep: string;
    lagradouro: string;
    numeroLagradouto: string;
    complemento: string;
    bairro: string;
    telefone: string;
    telefoneCelular: string;
    operadora: string;
    cpf: string;
    rg: string;
    orgaoExpedidorRG: string;
    nacionalidade: string;
    racaPaciente: string;
    situacao: string;
    idConvenio: number;
    nomeConvenio: string;
    carteiraConvenio: string;
    validadeCarteiraConvenio: Date;  

}